<!-- Top Header Bar - Hidden -->
<!--
<div class="top-header">
  <div class="header-left">
    <button class="menu-btn icon-btn">
      <i class="fa fa-bars"></i>
    </button>
    <div class="logo">
      <i class="fa fa-comments"></i>
      <span>Voice</span>
    </div>
  </div>
  <div class="header-search">
    <i class="fa fa-search"></i>
    <input type="text" placeholder="Search Google Voice" [(ngModel)]="searchText" />
  </div>
  <div class="header-right">
    <button class="icon-btn" title="Receiving calls">
      <i class="fa fa-phone"></i>
    </button>
    <button class="icon-btn" [class.active-view]="viewMode() === 'archived'" (click)="toggleArchiveView()" [title]="viewMode() === 'inbox' ? 'View archived' : 'View inbox'">
      <i class="fa fa-archive"></i>
    </button>
    <button class="icon-btn" title="Settings">
      <i class="fa fa-cog"></i>
    </button>
    <button class="icon-btn" title="Help">
      <i class="fa fa-question-circle"></i>
    </button>
    <button class="icon-btn" title="Apps">
      <i class="fa fa-th"></i>
    </button>
    <div class="user-avatar">
      <img [src]="session.user?.avatarUrl || 'https://avatar.iran.liara.run/public/1'" alt="User" />
    </div>
  </div>
</div>
-->

<div class="chat-container">
  <!-- Left Panel - Contacts List -->
  <div class="contacts-panel">
    <!-- Selection Toolbar -->
    @if (selectionMode()) {
      <div class="selection-toolbar">
        <div class="selection-info">
          <button class="icon-btn" (click)="toggleSelectionMode()" title="Cancel selection">
            <i class="fa fa-times"></i>
          </button>
          <span class="selection-count">{{ selectedThreads().size }}</span>
        </div>
        <div class="selection-actions">
          @if (viewMode() === 'inbox') {
            <button class="icon-btn" (click)="archiveSelectedThreads()" [disabled]="selectedThreads().size === 0" title="Archive">
              <i class="fa fa-archive"></i>
            </button>
            <button class="icon-btn" (click)="deleteSelectedThreads()" [disabled]="selectedThreads().size === 0" title="Delete">
              <i class="fa fa-trash"></i>
            </button>
          } @else if (viewMode() === 'archived') {
            <button class="icon-btn" (click)="unarchiveSelectedThreads()" [disabled]="selectedThreads().size === 0" title="Restore to inbox">
              <i class="fa fa-inbox"></i>
            </button>
            <button class="icon-btn" (click)="deleteSelectedThreads()" [disabled]="selectedThreads().size === 0" title="Delete permanently">
              <i class="fa fa-trash"></i>
            </button>
          } @else {
            <button class="icon-btn" (click)="restoreSelectedThreads()" [disabled]="selectedThreads().size === 0" title="Restore to inbox">
              <i class="fa fa-undo"></i>
            </button>
            <button class="icon-btn" (click)="permanentlyDeleteSelectedThreads()" [disabled]="selectedThreads().size === 0" title="Delete permanently">
              <i class="fa fa-trash-alt"></i>
            </button>
          }
        </div>
      </div>
    }

    <div class="contacts-header" [class.hidden]="selectionMode()">
      <div class="header-top">
        <h2 class="inbox-title">{{ getViewTitle() }}</h2>
        <div class="header-actions">
          <button class="icon-btn" (click)="openComposeDialog()" title="New SMS">
            <i class="fa fa-plus-circle"></i>
          </button>
          <button class="icon-btn" [class.active-view]="viewMode() !== 'inbox'" (click)="toggleArchiveView()" [title]="getNextViewTooltip()">
            <i class="fa" [ngClass]="getViewIcon()"></i>
          </button>
          <button class="icon-btn" title="More options">
            <i class="fa fa-ellipsis-v"></i>
          </button>
        </div>
      </div>
      <div class="search-box">
        <i class="fa fa-search"></i>
        <input type="text" placeholder="Search messages" [(ngModel)]="searchText" />
      </div>
    </div>

    <div class="contacts-list">
      @for (thread of threads(); track thread._id) {
        <div
          class="contact-item"
          [class.active]="selectedThread()?._id === thread._id"
          [class.unread]="thread.unreadCount && thread.unreadCount > 0"
          [class.selected]="isThreadSelected(thread._id)"
          (click)="selectionMode() ? toggleThreadSelection(thread._id) : selectThread(thread)"
        >
          @if (selectionMode()) {
            <div class="selection-checkbox" [class.checked]="isThreadSelected(thread._id)">
              <i class="fa" [class.fa-check]="isThreadSelected(thread._id)"></i>
            </div>
          } @else {
            <kendo-avatar
              [imageSrc]="getAvatarUrl(thread)"
              shape="circle"
              width="45px"
              height="45px"
              (click)="$event.stopPropagation(); toggleSelectionMode(); toggleThreadSelection(thread._id)"
              style="cursor: pointer;"
            ></kendo-avatar>
          }

          <div class="contact-info">
            <div class="contact-name">
              @if (isPhoneNumber(getContactName(thread))) {
                {{ getContactName(thread) | phone }}
              } @else {
                {{ getContactName(thread) }}
              }
            </div>
            <div class="contact-message">{{ (thread.text && thread.text !== 'None') ? thread.text : '📎 Attachment' }}</div>
          </div>

          <div class="contact-meta">
            <div class="contact-time">{{ getTimeLabel(thread.occurred_at) }}</div>
            @if (thread.unreadCount && thread.unreadCount > 0) {
              <span class="unread-badge">{{ thread.unreadCount }}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Right Panel - Chat Area -->
  <div class="chat-panel">
    @if (selectedThread()) {
      <div class="chat-header">
        <kendo-avatar
          [imageSrc]="getAvatarUrl(selectedThread()!)"
          shape="circle"
          width="40px"
          height="40px"
        ></kendo-avatar>
        <div class="chat-header-info">
          <div class="chat-header-name">
            @if (isPhoneNumber(getContactName(selectedThread()!))) {
              {{ getContactName(selectedThread()!) | phone }}
            } @else {
              {{ getContactName(selectedThread()!) }}
            }
          </div>
        </div>
      </div>

      <div class="chat-messages" #messagesContainer>
        @if (messages().length === 0) {
          <div class="text-center text-muted py-5">
            <p>No messages yet</p>
          </div>
        } @else {
          @for (message of messages(); track message._id) {
            <div class="message-wrapper" [class.my-message]="isMyMessage(message)">
              @if (!isMyMessage(message)) {
                <kendo-avatar
                  [imageSrc]="getAvatarUrl(selectedThread()!)"
                  shape="circle"
                  width="32px"
                  height="32px"
                  class="message-avatar"
                ></kendo-avatar>
              }
              <div class="message-bubble" [class.sent]="isMyMessage(message)" [class.received]="!isMyMessage(message)">
                @if (message.media && message.media.length > 0) {
                  <div class="message-media">
                    @for (attachment of message.media; track $index) {
                      @if (attachment.content_type?.startsWith('image/')) {
                        <img [src]="attachment.url" alt="Attachment" class="media-image" (click)="openMedia(attachment.url)" />
                      } @else {
                        <a [href]="attachment.url" target="_blank" class="media-link">
                          <i class="fa fa-file"></i>
                          <span>{{ getFileName(attachment.url) }}</span>
                        </a>
                      }
                    }
                  </div>
                }
                @if (message.text && message.text !== 'None') {
                  <div class="message-text">{{ message.text }}</div>
                }
                <div class="message-time">{{ getMessageTime(message.occurred_at) }}</div>
              </div>
              @if (isMyMessage(message)) {
                <kendo-avatar
                  [imageSrc]="getBusinessAvatarUrl()"
                  shape="circle"
                  width="32px"
                  height="32px"
                  class="message-avatar"
                ></kendo-avatar>
              }
            </div>
          }
        }
      </div>

      <div class="chat-input-area">
        <!-- Attached Files Display -->
        @if (attachedFiles().length > 0) {
          <div class="attached-files-preview">
            @for (file of attachedFiles(); track $index) {
              <div class="attached-file-item">
                <i class="fa fa-file"></i>
                <span class="file-name">{{ file.name }}</span>
                <button class="remove-file-btn" (click)="removeAttachment($index)" title="Remove file">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            }
          </div>
        }

        <div class="chat-input-wrapper">
          <kendo-avatar
            [imageSrc]="getBusinessAvatarUrl()"
            shape="circle"
            width="35px"
            height="35px"
          ></kendo-avatar>
          <input
            type="text"
            class="chat-input"
            placeholder="Type message"
            [(ngModel)]="currentMessage"
            (keyup.enter)="sendMessage()"
          />
          <button class="template-btn" (click)="toggleTemplateMenu()" title="Templates">
            <i class="fa fa-ellipsis-h"></i>
          </button>
          <input type="file" id="chat-file-input" style="display: none" multiple (change)="onFileSelected($event)" />
          <button class="attach-btn" (click)="triggerFileInput()" title="Attach file">
            <i class="fa fa-paperclip"></i>
          </button>
          <button class="emoji-btn" (click)="toggleEmojiPicker()" title="Add emoji">
            <i class="fa fa-smile"></i>
          </button>
          <button class="send-btn" (click)="sendMessage()" [disabled]="!currentMessage.trim() && attachedFiles().length === 0">
            <i class="fa fa-paper-plane"></i>
          </button>
        </div>

        <!-- Template Menu -->
        @if (showTemplateMenu()) {
          <div class="template-menu">
            <div class="template-menu-header">
              <span>Quick Replies</span>
              <button class="close-template-btn" (click)="toggleTemplateMenu()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="template-list">
              @for (template of templateTexts; track template) {
                <button class="template-item" (click)="selectTemplate(template)">
                  {{ template }}
                </button>
              }
            </div>
          </div>
        }

        <!-- Emoji Picker -->
        @if (showEmojiPicker()) {
          <div class="emoji-picker">
            <div class="emoji-picker-header">
              <span>Select Emoji</span>
              <button class="close-emoji-btn" (click)="toggleEmojiPicker()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="emoji-grid">
              @for (emoji of emojis; track emoji) {
                <button class="emoji-item" (click)="selectEmoji(emoji)">
                  {{ emoji }}
                </button>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="chat-empty">
        <div class="text-center text-muted">
          <i class="fa fa-comments fa-3x mb-3"></i>
          <h4>Select a conversation</h4>
          <p>Choose a conversation from the left to start messaging</p>
        </div>
      </div>
    }
  </div>

  <!-- Right Panel - Contact Info -->
  <div class="contact-info-panel">
    @if (selectedThread()) {
      @if (isEditingContact()) {
        <!-- Edit Mode -->
        <div class="contact-edit-header">
          <h3>Edit Contact</h3>
          <div class="edit-actions">
            <button class="icon-btn" (click)="cancelEditingContact()" title="Cancel">
              <i class="fa fa-times"></i>
            </button>
            <button class="icon-btn save-btn" (click)="saveContactChanges()" title="Save">
              <i class="fa fa-check"></i>
            </button>
          </div>
        </div>

        <div class="contact-edit-content">
          <!-- Avatar Editor -->
          <div class="avatar-editor">
            <div class="avatar-preview">
              <kendo-avatar
                [imageSrc]="editContactAvatar()"
                shape="circle"
                width="80px"
                height="80px"
              ></kendo-avatar>
              <button class="change-avatar-btn" (click)="toggleAvatarPicker()">
                <i class="fa fa-camera"></i>
              </button>
            </div>

            @if (showAvatarPicker()) {
              <div class="avatar-picker">
                <div class="avatar-picker-header">
                  <span>Choose Avatar</span>
                  <button class="close-picker-btn" (click)="toggleAvatarPicker()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="avatar-grid">
                  @for (avatarUrl of getAvatarOptions(); track avatarUrl) {
                    <div class="avatar-option" (click)="selectAvatar(avatarUrl)">
                      <img [src]="avatarUrl" alt="Avatar" />
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <!-- Name Editor -->
          <div class="form-group">
            <label>Contact Name</label>
            <input
              type="text"
              class="contact-name-input"
              [(ngModel)]="editContactName"
              placeholder="Enter contact name"
            />
          </div>

          <!-- Phone Number (Read-only) -->
          <div class="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              class="contact-phone-input"
              [value]="getPhoneNumber(selectedThread()!) | phone"
              readonly
            />
          </div>
        </div>
      } @else {
        <!-- View Mode -->
        <div class="contact-info-header">
          <kendo-avatar
            [imageSrc]="getAvatarUrl(selectedThread()!)"
            shape="circle"
            width="80px"
            height="80px"
          ></kendo-avatar>
          <h3 class="contact-info-name">
            @if (isPhoneNumber(getContactName(selectedThread()!))) {
              {{ getContactName(selectedThread()!) | phone }}
            } @else {
              {{ getContactName(selectedThread()!) }}
            }
          </h3>
        </div>

        <div class="contact-info-section">
          <div class="contact-info-item">
            <i class="fa fa-phone"></i>
            <div class="contact-info-details">
              <label>Phone Number</label>
              <span>{{ getPhoneNumber(selectedThread()!) | phone }}</span>
            </div>
          </div>
        </div>

        <div class="contact-info-section">
          <h4 class="section-title">Options</h4>
          <button class="contact-info-button" (click)="startEditingContact()">
            <i class="fa fa-edit"></i>
            <span>Edit contact</span>
          </button>
          <button class="contact-info-button">
            <i class="fa fa-bell-slash"></i>
            <span>Mute notifications</span>
          </button>

          @if (viewMode() === 'inbox') {
            <button class="contact-info-button" (click)="archiveCurrentThread()">
              <i class="fa fa-archive"></i>
              <span>Archive conversation</span>
            </button>
            <button class="contact-info-button danger" (click)="deleteCurrentThread()">
              <i class="fa fa-trash"></i>
              <span>Delete conversation</span>
            </button>
          } @else if (viewMode() === 'archived') {
            <button class="contact-info-button" (click)="unarchiveCurrentThread()">
              <i class="fa fa-inbox"></i>
              <span>Restore to inbox</span>
            </button>
            <button class="contact-info-button danger" (click)="deleteCurrentThread()">
              <i class="fa fa-trash"></i>
              <span>Delete permanently</span>
            </button>
          } @else {
            <button class="contact-info-button" (click)="restoreCurrentThread()">
              <i class="fa fa-undo"></i>
              <span>Restore to inbox</span>
            </button>
            <button class="contact-info-button danger" (click)="permanentlyDeleteCurrentThread()">
              <i class="fa fa-trash-alt"></i>
              <span>Delete permanently</span>
            </button>
          }
        </div>
      }
    } @else {
      <div class="contact-info-empty">
        <i class="fa fa-user fa-3x"></i>
        <p>Select a conversation to view contact details</p>
      </div>
    }
  </div>
</div>

<!-- Compose Message Dialog -->
@if (showComposeDialog()) {
  <div class="compose-dialog-overlay" (click)="closeComposeDialog()">
    <div class="compose-dialog" (click)="$event.stopPropagation()">
      <!-- Dialog Header -->
      <div class="compose-header">
        <h3>New Message</h3>
        <button class="close-btn" (click)="closeComposeDialog()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- To Field -->
      <div class="compose-to-field">
        <span class="to-label">To:</span>
        <input
          type="text"
          class="to-input"
          [(ngModel)]="composeRecipient"
          placeholder="Enter phone number (e.g., +1234567890)"
          [class.error]="recipientError()"
        />
      </div>
      @if (recipientError()) {
        <div class="error-message">{{ recipientError() }}</div>
      }

      <!-- Messages Area -->
      <div class="compose-messages">
        @if (composeMessage) {
          <div class="message-preview">
            <div class="message-bubble sent">
              <div class="message-text">{{ composeMessage }}</div>
            </div>
          </div>
        } @else {
          <div class="compose-empty">
            <i class="fa fa-comments fa-3x"></i>
            <p>Type your message below</p>
          </div>
        }
      </div>

      <!-- Input Area -->
      <div class="compose-input-area">
        <!-- Attached Files Display -->
        @if (composeAttachedFiles().length > 0) {
          <div class="attached-files-preview">
            @for (file of composeAttachedFiles(); track $index) {
              <div class="attached-file-item">
                <i class="fa fa-file"></i>
                <span class="file-name">{{ file.name }}</span>
                <button class="remove-file-btn" (click)="removeComposeAttachment($index)" title="Remove file">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            }
          </div>
        }

        <div class="compose-input-wrapper">
          <kendo-avatar
            [imageSrc]="getBusinessAvatarUrl()"
            shape="circle"
            width="35px"
            height="35px"
          ></kendo-avatar>
          <textarea
            class="compose-textarea"
            [(ngModel)]="composeMessage"
            placeholder="Type message"
            [class.error]="messageError()"
            rows="1"
            (keydown)="onComposeKeydown($event)"
          ></textarea>
          <button class="template-btn" (click)="toggleTemplateMenu()" title="Templates">
            <i class="fa fa-ellipsis-h"></i>
          </button>
          <input type="file" id="compose-file-input" style="display: none" multiple (change)="onComposeFileSelected($event)" />
          <button class="attach-btn" (click)="triggerComposeFileInput()" title="Attach file">
            <i class="fa fa-paperclip"></i>
          </button>
          <button class="emoji-btn" (click)="toggleComposeEmojiPicker()" title="Add emoji">
            <i class="fa fa-smile"></i>
          </button>
          <button class="send-btn" (click)="sendNewMessage()" [disabled]="(!composeMessage.trim() && composeAttachedFiles().length === 0) || isSending()">
            @if (isSending()) {
              <i class="fa fa-spinner fa-spin"></i>
            } @else {
              <i class="fa fa-paper-plane"></i>
            }
          </button>
        </div>

        <!-- Template Menu for Compose Dialog -->
        @if (showTemplateMenu()) {
          <div class="template-menu">
            <div class="template-menu-header">
              <span>Quick Replies</span>
              <button class="close-template-btn" (click)="toggleTemplateMenu()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="template-list">
              @for (template of templateTexts; track template) {
                <button class="template-item" (click)="selectComposeTemplate(template)">
                  {{ template }}
                </button>
              }
            </div>
          </div>
        }

        <!-- Emoji Picker for Compose Dialog -->
        @if (showComposeEmojiPicker()) {
          <div class="emoji-picker">
            <div class="emoji-picker-header">
              <span>Select Emoji</span>
              <button class="close-emoji-btn" (click)="toggleComposeEmojiPicker()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="emoji-grid">
              @for (emoji of emojis; track emoji) {
                <button class="emoji-item" (click)="selectComposeEmoji(emoji)">
                  {{ emoji }}
                </button>
              }
            </div>
          </div>
        }

        @if (messageError()) {
          <div class="error-message">{{ messageError() }}</div>
        }
        <div class="char-count">{{ composeMessage.length }} characters</div>
      </div>
    </div>
  </div>
}

<!-- Delete Confirmation Dialog -->
@if (showDeleteDialog()) {
<kendo-dialog
  title="Delete Conversation"
  [width]="400"
  (close)="cancelDelete()"
>
  <p>Are you sure you want to delete this conversation? This action cannot be undone.</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="cancelDelete()">Cancel</button>
    <button kendoButton themeColor="error" (click)="confirmDelete()">Delete</button>
  </kendo-dialog-actions>
</kendo-dialog>
}
